/**
 * 导入数据-管道流水-结束
 */
 export const importPipelineFlowStop = (item,stopParameter) => {
    let stopPipe = item.pipelineFlow.stopParameter
    if (stopPipe.dataType == 'Bool') {//stop 管道流水 Bool类型
        let boolData = {}
        let realData = {
            formulaType: 'empty',
            tag: '',
            unit: '',
            realTagData: [
                {
                    tag: '',
                    tagDrawer: false,
                    tagRadio: '',
                },
                {
                    tag: '',
                    tagDrawer: false,
                    tagRadio: '',
                }
            ]
        }
        let boolTagData = []
        if (stopPipe.boolData.formulaType == 'empty') {//Bool类型 运算符为 '无'
            boolData = {
                formulaType: stopPipe.boolData.formulaType,
                tag: stopPipe.boolData.tag,
                tagValue: stopPipe.boolData.tagValue,
                boolTagData: [
                    {
                        tag: '',
                        tagDrawer: false,
                        tagRadio: '',
                    },
                    {
                        tag: '',
                        tagDrawer: false,
                        tagRadio: '',
                    }
                ]
            }
        }
        if (stopPipe.boolData.formulaType == '&') {//Bool类型 运算符为 '&'
            let arr = stopPipe.boolData.tag.split('&')
            arr.forEach(arrv => {
                boolTagData.push({
                    tag: arrv,
                    tagDrawer: false,
                    tagRadio: '',
                })
            })
            boolData = {
                formulaType: stopPipe.boolData.formulaType,
                tag: '',
                tagValue: stopPipe.boolData.tagValue,
                boolTagData: boolTagData
            }
        }
        if (stopPipe.boolData.formulaType == '||') {//Bool类型 运算符为 '||'
            let arr = stopPipe.boolData.tag.split('||')
            arr.forEach(arrv => {
                boolTagData.push({
                    tag: arrv,
                    tagDrawer: false,
                    tagRadio: '',
                })
            })
            boolData = {
                formulaType: stopPipe.boolData.formulaType,
                tag: '',
                tagValue: stopPipe.boolData.tagValue,
                boolTagData: boolTagData
            }
        }
        if (stopPipe.boolData.formulaType == '!') {//Bool类型 运算符为 '!'
            boolData = {
                formulaType: stopPipe.boolData.formulaType,
                tag: stopPipe.boolData.tag,
                tagValue: stopPipe.boolData.tagValue,
                boolTagData: [
                    {
                        tag: '',
                        tagDrawer: false,
                        tagRadio: '',
                    },
                    {
                        tag: '',
                        tagDrawer: false,
                        tagRadio: '',
                    }
                ]
            }
        }

        stopParameter = {
            dataType: stopPipe.dataType,
            boolData: boolData,
            realData: realData,
            display: stopPipe.display,
            tagDrawer: false,
            tagRadio: '',
        }
    }
    if (stopPipe.dataType == 'Real') {//stop 管道流水 Real类型
        let boolData = {
            formulaType: 'empty',
            tag: '',
            tagValue: '',
            boolTagData: [
                {
                    tag: '',
                    tagDrawer: false,
                    tagRadio: '',
                },
                {
                    tag: '',
                    tagDrawer: false,
                    tagRadio: '',
                }
            ]
        }
        let realData = {}
        let realTagData = []
        if (stopPipe.realData.formulaType == 'empty') {//Real类型 运算符为 '无'
            realData = {
                formulaType: stopPipe.realData.formulaType,
                tag: stopPipe.realData.tag,
                unit: stopPipe.realData.unit,
                realTagData: [
                    {
                        tag: '',
                        tagDrawer: false,
                        tagRadio: '',
                    },
                    {
                        tag: '',
                        tagDrawer: false,
                        tagRadio: '',
                    }
                ]
            }
        }
        if (stopPipe.realData.formulaType == '+') {//Real类型 运算符为 '+'
            let arr = stopPipe.realData.tag.split('+')
            arr.forEach(arrv => {
                realTagData.push({
                    tag: arrv,
                    tagDrawer: false,
                    tagRadio: '',
                })
            })
            realData = {
                formulaType: stopPipe.realData.formulaType,
                tag: '',
                unit: stopPipe.realData.unit,
                realTagData: realTagData
            }
        }
        if (stopPipe.realData.formulaType == '-') {//Real类型 运算符为 '-'
            let arr = stopPipe.realData.tag.split('-')
            arr.forEach(arrv => {
                realTagData.push({
                    tag: arrv,
                    tagDrawer: false,
                    tagRadio: '',
                })
            })
            realData = {
                formulaType: stopPipe.realData.formulaType,
                tag: '',
                unit: stopPipe.realData.unit,
                realTagData: realTagData
            }
        }

        stopParameter = {
            dataType: stopPipe.dataType,
            boolData: boolData,
            realData: realData,
            display: stopPipe.display,
            tagDrawer: false,
            tagRadio: '',
        }
    }
    return stopParameter
}